<template>
	<div>
		<!-- 头条要闻 开始-->
		<hometoutiao @showLogin="showLogin"/>
		<!-- 头条要闻 结束-->
		<div class="w1200">    
		  <dl class="w50">
		    <dd>
		      <!-- 热搜推荐 开始-->
		      <homeresou @showLogin="showLogin"/>
		      <!-- 热搜推荐 结束-->
		    </dd>
		    <dd>
		      <!-- 专题热点 开始-->
		      <homehuati/>
		      <!-- 专题热点 结束-->
		    </dd>
		    <dd>
		      <!-- 寰球视野 开始-->
		      <homehuanqiu @showLogin="showLogin"/>
		      <!-- 寰球视野 结束-->
		    </dd>
		    <dd>
		      <!-- 技术前沿 开始-->
		      <homejishu @showLogin="showLogin" />
		      <!-- 技术前沿 结束-->
		    </dd>
		  </dl>
		</div>
		<!-- 专家研判 研究速递 开始-->
		<div class="wap">
		  <div class="w1200">
		    <dl class="w50">
		      <dd>
		        <homeguandian @showLogin="showLogin"></homeguandian>
		      </dd>
		      <dd>
		        <homebaogao @showLogin="showLogin"></homebaogao>
		      </dd>
		    </dl>
		  </div>
		</div>
		<!-- 专家研判 研究速递 开始-->
		<div class="w1200">
		  <homeyuntu></homeyuntu>
		  <dl class="w50">
		    <dd>
		      <!-- 创新实践 开始-->
		      <homeshijian @showLogin="showLogin"></homeshijian>
		      <!-- 创新实践 结束-->
		    </dd>
		    <dd>
		      <!-- 政策规划 开始-->
		      <homezhengce @showLogin="showLogin"></homezhengce>
		      <!-- 政策规划 结束-->
		    </dd>
		  </dl>
			<homezhiku @showLogin="showLogin"></homezhiku>
		</div>
	</div>
</template>

<script>
	import hometoutiao from '@/components/home-toutiao.vue'
	import homeresou from '@/components/home-resou.vue'
	import homehuati from '@/components/home-huati.vue'
	import homehuanqiu from '@/components/home-huanqiu.vue'
	import homejishu from '@/components/home-jishu.vue'
	import homeguandian from '@/components/home-guandian.vue'
	import homebaogao from '@/components/home-baogao.vue'
	import homeyuntu from '@/components/home-yuntu2.vue'
	import homeshijian from '@/components/home-shijian.vue'
	import homezhengce from '@/components/home-zhengce.vue'
	import homezhiku from '@/components/home-zhiku.vue'
	
	export default {
		name: 'home',
		components: {
			hometoutiao,
			homeresou,
			homehuati,
			homehuanqiu,
			homejishu,
			homeguandian,
			homebaogao,
			homeyuntu,
			homeshijian,
			homezhengce,
			homezhiku,
		},
		created:function(){
			
		},
		mounted:function(){
			document.title='首页-数字中国专版';
			this.$track([
				['pagetype','首页']
			]);
		},
		methods:{
			showLogin: function() {
				this.$emit('showLogin');
			},
		},
		beforeRouteLeave(to,from,next){
			if(!this.$cookies.get('userinfo')){
				// alert('未登录');
				this.showLogin();
				next(false);
			}
			else{
				next();
			}
		}
	}
</script>

<style>
</style>
